export default {
  label: {
    series: {
      receivedMessages: 'Mensagens recebidas',
      sentMessages: 'Mensagens enviadas',
    },
  },
};
